export default [
    {
        path: 'agendamento/parametros-servicos-por-local',
        name: 'agendamento.servicos-por-local',
        component: () => import('./scheduling-service-locations/Index.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoLocalController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-servicos-por-local/cadastrar',
        name: 'agendamento.servicos-por-local.create',
        component: () => import('./scheduling-service-locations/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoLocalController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-servicos-por-local/:id/editar',
        name: 'agendamento.servicos-por-local.edit',
        component: () => import('./scheduling-service-locations/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoLocalController', scheduling: true },
    },
    {
        path: 'agendamento/grupos-servicos',
        name: 'agendamento.grupos-servicos',
        component: () => import('./scheduling-service-groups/Index.vue'),
        meta: { middleware: 'auth', controller: 'ParametroGrupoServicoController', scheduling: true },
    },
    {
        path: 'agendamento/grupos-servicos/cadastrar',
        name: 'agendamento.grupos-servicos.create',
        component: () => import('./scheduling-service-groups/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroGrupoServicoController', scheduling: true },
    },
    {
        path: 'agendamento/grupos-servicos/:id/editar',
        name: 'agendamento.grupos-servicos.edit',
        component: () => import('./scheduling-service-groups/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroGrupoServicoController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-servicos',
        name: 'agendamento.servicos',
        component: () => import('./scheduling-services/Index.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-servicos/cadastrar',
        name: 'agendamento.servicos.create',
        component: () => import('./scheduling-services/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-servicos/:id/editar',
        name: 'agendamento.servicos.edit',
        component: () => import('./scheduling-services/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroServicoController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-locais',
        name: 'agendamento.locais',
        component: () => import('./scheduling-locations/Index.vue'),
        meta: { middleware: 'auth', controller: 'ParametroLocalController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-locais/cadastrar',
        name: 'agendamento.locais.create',
        component: () => import('./scheduling-locations/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroLocalController', scheduling: true },
    },
    {
        path: 'agendamento/parametros-locais/:id/editar',
        name: 'agendamento.locais.edit',
        component: () => import('./scheduling-locations/Form.vue'),
        meta: { middleware: 'auth', controller: 'ParametroLocalController', scheduling: true },
    },
    {
        path: 'admin/parametros/:aba?',
        name: 'admin.parametros',
        component: require('./Index').default,
        meta: { middleware: 'auth', controller: 'ConfiguracaoController' }
    },
    {
        path: 'admin/sms',
        component: require('./Sms').default,
        meta: { middleware: 'auth', controller: 'ConfiguracaoController' }
    },
    {
        path: 'admin/tema-dinamico',
        component: require('./TemaDinamico').default,
        meta: {
            middleware: 'auth',
            controller: 'TemasDinamicosController'
        }
    },
    {
        path: 'admin/tema-dinamico/novo',
        name: 'NovoTemaDinamico',
        component: require('./TemaDinamicoForm').default,
        meta: {
            middleware: 'auth',
            controller: 'TemasDinamicosController'
        }
    },
    {
        path: 'admin/tema-dinamico/:id',
        name: 'EditarTemaDinamico',
        component: require('./TemaDinamicoForm').default,
        props: true,
        meta: {
            middleware: 'auth',
            controller: 'TemasDinamicosController'
        }
    }
];


